var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-body"},_vm._l((_vm.tags),function(tag,index){return _c('el-tag',{key:tag.name,class:index !== 0 ? 'margin-left-15' : '',attrs:{"closable":"","type":tag.type}},[_vm._v("\n    "+_vm._s(tag.name)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa982ff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/16/Tag/index.vue
// module id = 3y2L
// module chunks = 0